import React from "react";

import AssignBoardOwner from "./AssignBoardOwner";
import UpdateBoardName from "./UpdateName";
import OwnerLogo from "./OwnerLogo";
import { normalizeBoardHeaderData } from "../hooks/boardHeaderUtils";

function BoardName({ boardName }) {
  const board = normalizeBoardHeaderData(boardName);

  return (
    <>
      <AssignBoardOwner board={board} />
      <UpdateBoardName board={board} />
      {/* <OwnerLogo boardName={boardName} /> */}
    </>
  );
}

export default BoardName;
